/** 고정된 모의 카탈로그를 사용하는 재현 가능한 브라우저 데모. 학습·외부 API 호출은 하지 않는다. */

export const CATALOG = {
  data_source: 'synthetic_demo',
  as_of: '2026-08-24',
  market: { indicator: 'consumer_price_index', value: 113.2, period: '2026-07', seasonal_idx: 1.18 },
  products: [
    {
      product_id: 'P-1001', sku: 'SKU-30412', product_name: '토너 비타민 앰플 300ml',
      price: 42900, category: '스킨케어', stock: 1250, channel: '자사몰', brand: 'MarketFit',
      description: '비타민 토너 앰플. 보습이 오래가고 향이 은은하다.', image_file: 'toner_ampoule.jpg',
      ad_metrics: { ctr: 0.041, cpc: 320, roas: 3.2, purchase: 42, spend: 13440 },
      behavior: { rebuy: 0.22, dwell: 48, subscribe: true, cvr: 0.038, views: 1840, carts: 92 },
      sales_seed: { base: 52, trend: 0.06, seasonal: 1.18, noise: 0.10, promo_day: 78 },
      search_trend: { query: '비타민 토너 앰플', index: 86, wow: 0.12 },
      cs: [{ ticket_id: 'CS-1001-01', channel: 'kakao', text: '재구매 할인도 되나요? 보습이 좋아서 또 사고 싶어요.' }],
      reviews: [
        '배송 빠르고 포장 꼼꼼해요. 보습이 오래가고 향이 은은해요.',
        '가격은 조금 있지만 재구매 의사 있어요. 사용감이 좋아요.',
        '촉촉하고 추천합니다. 발림성이 부드러워요.',
      ],
    },
    {
      product_id: 'P-1002', sku: 'SKU-30413', product_name: '레티놀 나이트크림 60ml',
      price: 38000, category: '스킨케어', stock: 180, channel: '오픈마켓', brand: 'MarketFit',
      description: '레티놀 나이트 크림. 야간 보습과 탄력 케어.', image_file: 'retinol_night.jpg',
      ad_metrics: { ctr: 0.028, cpc: 410, roas: 2.1, purchase: 18, spend: 7380 },
      behavior: { rebuy: 0.11, dwell: 31, subscribe: false, cvr: 0.021, views: 980, carts: 41 },
      sales_seed: { base: 38, trend: 0.12, seasonal: 1.05, noise: 0.16, promo_day: 22 },
      search_trend: { query: '레티놀 나이트크림', index: 71, wow: 0.09 },
      cs: [{ ticket_id: 'CS-1002-01', channel: 'email', text: '배송이 늦고 포장이 약했어요. 교환 가능한가요?' }],
      reviews: [
        '효과는 있는데 가격이 비싸요. 배송은 늦었어요.',
        '밤에 바르니 촉촉해요. 향은 보통이에요.',
        '문의 대응이 느리고 포장이 약했어요.',
      ],
    },
    {
      product_id: 'P-1003', sku: 'SKU-30414', product_name: '데일리 선크림 50ml',
      price: 18900, category: '스킨케어', stock: 950, channel: '자사몰', brand: 'MarketFit',
      description: '데일리 선크림. 백탁이 적고 사용감이 가볍다.', image_file: 'daily_sun.jpg',
      ad_metrics: { ctr: 0.019, cpc: 290, roas: 1.4, purchase: 11, spend: 3190 },
      behavior: { rebuy: 0.08, dwell: 22, subscribe: false, cvr: 0.014, views: 720, carts: 19 },
      sales_seed: { base: 24, trend: -0.04, seasonal: 1.16, noise: 0.14, promo_day: -1 },
      search_trend: { query: '데일리 선크림', index: 28, wow: -0.11 },
      cs: [{ ticket_id: 'CS-1003-01', channel: 'chat', text: '품질이 별로라 반품 문의합니다.' }],
      reviews: [
        '발림성은 좋은데 효과가 별로예요.',
        '가격은 괜찮은데 재구매는 고민돼요.',
        '향이 살짝 아쉬워요.',
      ],
    },
    {
      product_id: 'P-1004', sku: 'SKU-30415', product_name: '비타민C 세럼 30ml',
      price: 27400, category: '스킨케어', stock: 620, channel: '오픈마켓', brand: 'MarketFit',
      description: '비타민C 세럼. 톤업과 보습을 함께 잡는다.', image_file: 'vitc_serum.jpg',
      ad_metrics: { ctr: 0.033, cpc: 355, roas: 2.6, purchase: 27, spend: 9585 },
      behavior: { rebuy: 0.16, dwell: 40, subscribe: true, cvr: 0.029, views: 1310, carts: 64 },
      sales_seed: { base: 41, trend: 0.09, seasonal: 1.12, noise: 0.13, promo_day: 61 },
      search_trend: { query: '비타민C 세럼', index: 78, wow: 0.07 },
      cs: [{ ticket_id: 'CS-1004-01', channel: 'kakao', text: '용량 문의드려요. 향은 은은해서 재구매 고민 중이에요.' }],
      reviews: [
        '보습이 좋고 향이 은은해요. 추천합니다.',
        '사용감은 좋은데 가격이 살짝 부담돼요.',
        '배송 빠르고 포장 꼼꼼. 재구매 의사 있어요.',
      ],
    },
  ],
};

const ASPECTS = {
  shipping: { cues: ['배송', '포장', '늦'], pos: ['빠르', '꼼꼼', '안전'], neg: ['늦', '파손', '약했'], ko: '배송 만족도' },
  price: { cues: ['가격', '비싸', '부담'], pos: ['괜찮', '합리적'], neg: ['비싸', '부담'], ko: '가격 만족도' },
  quality: { cues: ['보습', '향', '효과', '촉촉', '품질'], pos: ['좋', '촉촉', '은은', '추천', '효과'], neg: ['별로', '아쉬', '실망'], ko: '품질 신뢰도' },
  usability: { cues: ['사용', '발림', '바르'], pos: ['좋', '부드럽', '가볍'], neg: ['불편', '끈적'], ko: '사용성 점수' },
};
/** 시장 적합성 PMF = 모델 가중합. 합=1 */
export const MODEL_W = { market: 0.30, xai: 0.30, forecast: 0.25, anomaly: 0.15 };
export const MODEL_KO = { market: '시장 성과', xai: '고객 반응', forecast: '수요 전망', anomaly: '운영 안정' };

function rng(seed) {
  let h = 2166136261;
  for (let i = 0; i < seed.length; i++) h = Math.imul(h ^ seed.charCodeAt(i), 16777619);
  return () => {
    h += 0x6d2b79f5;
    let t = Math.imul(h ^ (h >>> 15), 1 | h);
    t = t + Math.imul(t ^ (t >>> 7), 61 | t) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
function gauss(rand) {
  const u = Math.max(1e-9, rand());
  return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * rand());
}
function clip01(v) { return Math.max(0, Math.min(1, v)); }
function polarity(score) { return score >= 66 ? 'positive' : score <= 40 ? 'negative' : 'neutral'; }

function dailySales(product, days = 90) {
  const seed = product.sales_seed;
  const rand = rng(product.product_id);
  const asOf = new Date(`${CATALOG.as_of}T00:00:00Z`);
  const rows = [];
  for (let i = 0; i < days; i++) {
    const day = new Date(asOf);
    day.setUTCDate(day.getUTCDate() - (days - 1 - i));
    const yday = Math.floor((day - Date.UTC(day.getUTCFullYear(), 0, 0)) / 86400000);
    const seasonal = 1 + 0.12 * ((yday % 365) / 365 - 0.5) * (seed.seasonal - 1) * 8;
    const trend = seed.base * (1 + seed.trend * (i / days));
    const promo = i === seed.promo_day ? seed.base * 0.45 : 0;
    const units = Math.max(0, Math.round(trend * seasonal + gauss(rand) * seed.noise * seed.base + promo));
    rows.push({ date: day.toISOString().slice(0, 10), units });
  }
  return rows;
}

function absa(product) {
  const texts = [...product.reviews, ...(product.cs || []).map((row) => row.text)];
  const merged = { shipping: [], price: [], quality: [], usability: [] };
  const mentioned = { shipping: false, price: false, quality: false, usability: false };
  for (const text of texts) {
    for (const [aspect, lex] of Object.entries(ASPECTS)) {
      const hit = lex.cues.some((c) => text.includes(c));
      const pos = lex.pos.filter((w) => text.includes(w)).length;
      const neg = lex.neg.filter((w) => text.includes(w)).length;
      if (!hit && !pos && !neg) continue;
      mentioned[aspect] = true;
      const raw = (pos - neg) / Math.max(1, pos + neg);
      merged[aspect].push(Math.max(5, Math.min(95, Math.round(50 + 40 * raw))));
    }
  }
  const aspects = Object.keys(ASPECTS).map((aspect) => {
    const scores = merged[aspect];
    const score = scores.length ? Math.round(scores.reduce((a, b) => a + b, 0) / scores.length) : 50;
    return { aspect, name: ASPECTS[aspect].ko, score, polarity: polarity(score), mentioned: mentioned[aspect] };
  });
  const mean = aspects.reduce((s, a) => s + a.score, 0) / aspects.length;
  return { product_id: product.product_id, sku: product.sku, review_count: texts.length, aspects, absa_mean: Math.round(mean * 10) / 10, channel_score: Math.round((mean / 100) * 10000) / 10000, model: 'lexicon_absa', evaluation: 'not_validated' };
}

function forecast(product, history, horizon = 28) {
  const series = history.map((r) => r.units);
  const stock = product.stock;
  const n = series.length;
  const xMean = (n - 1) / 2;
  const yMean = series.reduce((a, b) => a + b, 0) / n;
  const varX = series.reduce((s, _, i) => s + (i - xMean) ** 2, 0) || 1;
  const slope = series.reduce((s, y, i) => s + (i - xMean) * (y - yMean), 0) / varX;
  const intercept = yMean - slope * xMean;
  const resid = series.map((y, i) => y - (intercept + slope * i));
  const sigma = Math.sqrt(resid.reduce((s, r) => s + r * r, 0) / n);
  const future = Array.from({ length: horizon }, (_, i) => intercept + slope * (n + i));
  let p50 = Math.max(0, future.reduce((a, b) => a + b, 0));
  const band = 1.2816 * sigma * Math.sqrt(horizon);
  let p10 = Math.max(0, p50 - band);
  let p90 = p50 + band;
  p10 = Math.round(p10 * 10) / 10;
  p50 = Math.round(p50 * 10) / 10;
  p90 = Math.round(p90 * 10) / 10;
  const safety = Math.round(Math.max(0, p90 - p50) * 10) / 10;
  const gap = p50 - stock;
  let status, action, order;
  if (stock <= 0 || (p50 > 0 && stock / p50 < 0.25)) { status = '부족'; action = '긴급보충'; order = Math.round(Math.max(gap, safety)); }
  else if (p50 > 0 && stock / p50 < 0.85) { status = '주의'; action = '재고보충'; order = Math.round(Math.max(gap, 0) + safety * 0.5); }
  else if (p50 > 0 && stock / p50 > 1.35) { status = '과잉'; action = '발주중단'; order = 0; }
  else { status = '적정'; action = '유지'; order = Math.round(Math.max(gap, 0)); }
  const cover = p50 > 0 ? stock / p50 : 1;
  let channel = clip01(1 - Math.abs(cover - 1));
  if (status === '부족') channel *= 0.55;
  else if (status === '주의') channel *= 0.8;
  return { product_id: product.product_id, sku: product.sku, product_name: product.product_name, lookback: n, horizon, p10, p50, p90, stock, demand_4w: p50, safety_stock: safety, order, status, action, channel_score: Math.round(channel * 10000) / 10000, model: 'linear_quantile_baseline', interval_method: 'normal_residual_approximation', evaluation: 'not_validated' };
}

function anomalies(products) {
  const keys = ['orders', 'stock', 'ctr', 'roas', 'cvr', 'price'];
  const vecs = products.map((p) => [p.ad_metrics.purchase, p.stock, p.ad_metrics.ctr, p.ad_metrics.roas, p.behavior.cvr, p.price / 10000]);
  const dim = keys.length;
  const mean = Array(dim).fill(0);
  vecs.forEach((v) => v.forEach((x, i) => { mean[i] += x; }));
  mean.forEach((_, i) => { mean[i] /= vecs.length; });
  const std = Array(dim).fill(0);
  vecs.forEach((v) => v.forEach((x, i) => { std[i] += (x - mean[i]) ** 2; }));
  std.forEach((_, i) => { std[i] = Math.sqrt(std[i] / vecs.length) || 1; });
  const mse = vecs.map((v) => {
    const z = v.map((x, i) => (x - mean[i]) / std[i]);
    return z.reduce((s, x) => s + x * x, 0) / dim;
  });
  const sorted = [...mse].sort((a, b) => a - b);
  const threshold = sorted[Math.max(0, Math.floor(sorted.length * 0.7))] || 1e-6;
  return products.map((p, i) => {
    const z = vecs[i].map((x, d) => ((x - mean[d]) / std[d]) ** 2);
    const total = z.reduce((a, b) => a + b, 0) || 1;
    const causes = keys.map((factor, d) => ({ factor, contribution: Math.round((z[d] / total) * 1000) / 1000 }))
      .sort((a, b) => b.contribution - a.contribution).slice(0, 4);
    const score = Math.min(99, Math.round((100 * mse[i]) / (threshold * 2 + 1e-9)));
    const state = mse[i] > threshold * 1.4 ? '이상' : mse[i] > threshold ? '주의' : '정상';
    const distance = Math.round(mse[i] * 1e5) / 1e5;
    // reconstruction_error remains a compatibility alias; this is not an autoencoder output.
    return { product_id: p.product_id, sku: p.sku, anomaly_score: score, state, standardized_distance: distance, reconstruction_error: distance, threshold: Math.round(threshold * 1e5) / 1e5, causes, channel_score: Math.round((1 - score / 100) * 10000) / 10000, model: 'zscore_baseline', explanation_method: 'squared_zscore_share', evaluation: 'not_validated' };
  });
}

function r4(v) { return Math.round(v * 10000) / 10000; }
function r1(v) { return Math.round((v + 1e-9) * 10) / 10; }

export function demoEmbedding(product) {
  return [0.12, -0.03, 0.44].map((v, i) => Math.round((v + (product.price % 17) * 0.001 * (i + 1)) * 1000) / 1000);
}

function marketTraction(product) {
  const ads = product.ad_metrics;
  const b = product.behavior;
  const ad = 0.5 * clip01(ads.roas / 4) + 0.3 * clip01(ads.ctr / 0.05) + 0.2 * clip01(ads.purchase / 50);
  const beh = 0.4 * clip01(b.rebuy / 0.3) + 0.3 * clip01(b.cvr / 0.05) + 0.3 * (b.subscribe ? 1 : 0.4);
  return r4(clip01(0.55 * ad + 0.45 * beh));
}

function forecastOutlook(f) {
  const heat = clip01(f.p50 / (f.p50 + f.stock + 1e-9));
  const serve = f.status === '적정' ? 1 : f.status === '주의' ? 0.72 : f.status === '부족' ? 0.52 : 0.38;
  const pull = f.status === '과잉' ? 0.32 : 0.45 + 0.55 * heat;
  return r4(clip01(0.58 * pull + 0.42 * serve));
}

function fitBand(score) {
  if (score >= 75) return { verdict: '강함', meaning: '데모 기준 75점 이상. 수요·감성·성과의 모의 가중합이 높음' };
  if (score >= 60) return { verdict: '양호', meaning: '데모 기준 60~75점 미만. 낮은 채널 점수의 근거를 확인' };
  if (score >= 45) return { verdict: '주의', meaning: '데모 기준 45~60점 미만. 낮은 채널 점수의 근거를 확인' };
  return { verdict: '약함', meaning: '데모 기준 45점 미만. 실제 시장 적합성은 별도 검증 필요' };
}

function scoreProduct(product, absaDoc, forecastDoc, anomalyDoc) {
  const ads = product.ad_metrics;
  const b = product.behavior;
  const scores = {
    market: marketTraction(product),
    xai: r4(absaDoc.absa_mean / 100),
    forecast: forecastOutlook(forecastDoc),
    anomaly: r4(clip01(1 - anomalyDoc.anomaly_score / 100)),
  };
  const parts = Object.keys(MODEL_W).map((model) => {
    const score01 = scores[model];
    const weight = MODEL_W[model];
    return {
      model,
      channel: model,
      label: MODEL_KO[model],
      score: r1(score01 * 100),
      w: weight,
      weight,
      contribution: r1(weight * r1(score01 * 100)),
      shap: r4(weight * score01),
    };
  }).sort((a, b) => b.contribution - a.contribution);

  const pmf = r1(Math.max(0, Math.min(100, parts.reduce((s, p) => s + p.contribution, 0))));
  const band = fitBand(pmf);
  const strongest = parts[0];
  const weakest = parts.reduce((lowest, part) => part.score < lowest.score ? part : lowest);
  const reasons = [
    { dir: '+', model: strongest.model, text: `${strongest.label} ${strongest.score}점 · 기여 ${strongest.contribution}` },
    { dir: weakest.score < 60 ? '-' : '+', model: weakest.model, text: `${weakest.label} ${weakest.score}점 · 기여 ${weakest.contribution}` },
  ];
  if (forecastDoc.status === '과잉') reasons.push({ dir: '-', model: 'forecast', text: `재고 과잉 · p50 ${forecastDoc.p50} < 재고 ${forecastDoc.stock}` });
  if (forecastDoc.status === '부족') reasons.push({ dir: '-', model: 'forecast', text: '재고 부족 · 수요는 있으나 공급이 못 따라감' });
  if (absaDoc.aspects.some((a) => a.polarity === 'negative')) {
    const weak = absaDoc.aspects.filter((a) => a.polarity === 'negative').map((a) => a.name);
    if (weak.length) reasons.push({ dir: '-', model: 'xai', text: `고객 약점 · ${weak.join(' · ')}` });
  }
  if (anomalyDoc.state !== '정상') {
    reasons.push({ dir: '-', model: 'anomaly', text: `운영 ${anomalyDoc.state} · 주원인 ${anomalyDoc.causes[0].factor}` });
  }

  const evidence = {
    market: { roas: ads.roas, ctr: ads.ctr, cvr: b.cvr, rebuy: b.rebuy, purchase: ads.purchase },
    xai: { absa_mean: absaDoc.absa_mean, aspects: absaDoc.aspects },
    forecast: { p10: forecastDoc.p10, p50: forecastDoc.p50, p90: forecastDoc.p90, status: forecastDoc.status, order: forecastDoc.order, stock: forecastDoc.stock },
    anomaly: { anomaly_score: anomalyDoc.anomaly_score, state: anomalyDoc.state, causes: anomalyDoc.causes },
  };
  parts.forEach((p) => { p.evidence = evidence[p.model]; });

  const agreement = r4(1 - parts.reduce((s, p) => s + Math.abs(p.score - pmf), 0) / (parts.length * 100));

  return {
    product_id: product.product_id,
    sku: product.sku,
    product_name: product.product_name,
    pmf_score: pmf,
    verdict: band.verdict,
    meaning: band.meaning,
    formula: 'PMF = 0.30·시장성과 + 0.30·XAI고객반응 + 0.25·수요전망 + 0.15·운영안정',
    confidence: r4(Math.max(0.4, Math.min(0.97, 0.55 + 0.45 * agreement))),
    confidence_kind: 'heuristic_agreement_not_probability',
    evaluation: 'not_validated',
    explanation_method: 'weighted_components',
    parts,
    weakest,
    // Legacy aliases used by the original visualizations; these are weighted components, not SHAP values.
    shap_top: parts,
    channel_scores: Object.fromEntries(Object.entries(scores).map(([k, v]) => [k, r1(v * 100)])),
    channel_weights: MODEL_W,
    reasons,
    inputs: {
      absa: absaDoc,
      forecast: evidence.forecast,
      anomaly: evidence.anomaly,
      ads: { ctr: ads.ctr, cpc: ads.cpc, roas: ads.roas, purchase: ads.purchase },
      behavior: { rebuy: b.rebuy, dwell: b.dwell, cvr: b.cvr, subscribe: b.subscribe },
      search_trend: product.search_trend,
      cs: product.cs,
    },
    model: 'pmf_model_fusion_v1',
  };
}

export function runPmf() {
  const products = CATALOG.products;
  const anom = anomalies(products);
  return products.map((p, i) => {
    const history = dailySales(p);
    const a = absa(p);
    const f = forecast(p, history);
    return { product: p, history, absa: a, forecast: f, anomaly: anom[i], pmf: scoreProduct(p, a, f, anom[i]) };
  });
}

export const PIPELINE = runPmf();
export const PMF_SCORES = PIPELINE.map((d) => d.pmf).sort((a, b) => b.pmf_score - a.pmf_score);
export const PMF_BY_ID = Object.fromEntries(PMF_SCORES.map((d) => [d.product_id, d]));
export const ABSA_BY_ID = Object.fromEntries(PIPELINE.map((d) => [d.product.product_id, d.absa]));
export const FORECAST_BY_ID = Object.fromEntries(PIPELINE.map((d) => [d.product.product_id, d.forecast]));
export const ANOMALY_BY_ID = Object.fromEntries(PIPELINE.map((d) => [d.product.product_id, d.anomaly]));
export const SALES_BY_ID = Object.fromEntries(PIPELINE.map((d) => [d.product.product_id, d.history]));
